import { Locale } from 'date-fns';
import { PropsWithChildren, createContext, useContext, useEffect, useState } from 'react';
import defaultLocale from 'date-fns/esm/locale/en-GB';

const resources: Record<string, () => Promise<{ default: Locale }>> = {
  en: () => Promise.resolve({ default: defaultLocale }),
  pl: () => import('date-fns/esm/locale/pl'),
  de: () => import('date-fns/esm/locale/de'),
};

type DateFNSConfigContextProps = {
  locale: Locale;
};

const DateFNSConfigContext = createContext<DateFNSConfigContextProps | null>(null);

export const useDateFNSConfig = () => {
  const context = useContext(DateFNSConfigContext);

  if (!context) {
    throw new Error('useDateFNSConfig must be used within a DateFNSConfigProvider');
  }

  return context;
};

type DateFNSConfigProviderProps = {
  language: string;
};

export const DateFNSConfigProvider = ({ children, language }: PropsWithChildren<DateFNSConfigProviderProps>) => {
  const [locale, setLocale] = useState<Locale>(defaultLocale);

  useEffect(() => {
    if (language) {
      resources[language]?.().then((locale) => {
        setLocale(locale.default);
      });
    }
  }, [language]);

  return <DateFNSConfigContext.Provider value={{ locale }}>{children}</DateFNSConfigContext.Provider>;
};
